import React, { useMemo } from 'react';
import { SupportRequestResultsResponse } from 'features/my-zone/support-requests/components/support-requests-modals/modals/request-new-location/request-property/types';
import { EAskFowReviewFormSectionType } from '../types';
import { useAskForReviewOptions } from '../use-ask-for-review-flow-options';
import { ChipList } from '../components/chip-list/chip-list';

export const ReviewOptions = ({
    onSelectChange,
    item,
}: {
    onSelectChange: (value: EAskFowReviewFormSectionType) => void;
    item: SupportRequestResultsResponse;
}) => {
    const { getOptions } = useAskForReviewOptions();
    const options = useMemo(
        () =>
            getOptions({
                status: item.challenge_status_override ?? item.status,
                entityId: item.entity_id,
                flag: item.report_type === 'Nearby' ? item.flag_reasons?.[0] : undefined,
            }),
        [
            getOptions,
            item.challenge_status_override,
            item.entity_id,
            item.flag_reasons,
            item.report_type,
            item.status,
        ],
    );

    return (
        <ChipList
            testId="review-options"
            options={options}
            onItemClick={({ value }) => onSelectChange(value)}
        />
    );
};
